module.exports = __webpack_public_path__ + "img/nationals.b57f6d7b.svg";